export default __webpack_public_path__ + "static/media/alphabet-yellow-j.fd6816ea.png";